import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

interface AuthHeadingProps {
  /** Kicker opcional (eyebrow). Pensado para "Paso 1 de 2", "Bienvenida", etc. */
  kicker?: ReactNode;
  /** Icono opcional sobre el kicker — se renderiza en una capsulita primary/10. */
  icon?: ReactNode;
  /** Título principal — display Fraunces. */
  title: ReactNode;
  /** Subtítulo corto en sans / muted. */
  subtitle?: ReactNode;
  className?: string;
}

/**
 * Encabezado estandarizado para pantallas de auth. Un solo lugar que
 * decide la jerarquía: eyebrow mono micro → display serif grande → body
 * muted. Mantiene ritmo vertical consistente entre Login, MFA, SessionExpired.
 */
export function AuthHeading({ kicker, icon, title, subtitle, className }: AuthHeadingProps) {
  return (
    <header className={cn("mb-10", className)}>
      {icon ? (
        <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/15">
          {icon}
        </div>
      ) : null}

      {kicker ? (
        <p className="font-mono text-[11px] font-medium uppercase tracking-[0.22em] text-primary">
          {kicker}
        </p>
      ) : null}

      <h1
        className={cn(
          "font-display font-medium tracking-display-tight text-foreground",
          "mt-2 text-[2.25rem] leading-[1.05] lg:text-[2.75rem]",
        )}
      >
        {title}
      </h1>

      {subtitle ? (
        <p className="mt-4 max-w-sm text-[0.9375rem] leading-relaxed text-muted-foreground">
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
